import { Cmd } from '../../tools/types';

function execute() {
  // using a dynamic import to ensure that the modified arguments in the prepare functions below
  // are set before loading the execute function
  import('./execute.js').then(({ execute }) => execute());
}

export const generate: Cmd = {
  name: 'generate',
  description: 'Generate documentation for the project',
  execute,
  prepare: () => {
    process.argv = [...process.argv.slice(0, 2), ...process.argv.slice(3)];
  },
  alias: ['g', 'new', 'create', 'gen'],
};

export const init: Cmd = {
  name: 'init',
  description: 'Initialize a new custom component project in the current directory',
  execute,
  prepare: () => {
    process.argv = [...process.argv.slice(0, 2), 'project', ...process.argv.slice(3)];
  },
  alias: [],
};

export const project: Cmd = {
  name: 'project',
  description: 'Initialize a new qodly project in the current directory',
  execute,
  prepare: () => {
    process.argv = [...process.argv.slice(0, 2), 'qodly-project', ...process.argv.slice(3)];
  },
  alias: [],
};
